import { Dropdown, Icon, Input } from "semantic-ui-react";
import { useMemo, useState, useRef, useEffect, memo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { formatEightNumber, formatNumber } from "../../../utils/formatNumber";
import {
  storeMemberInfo,
  storeTransferWallet,
} from "../../../redux/action/member/memberAction";
import CurrencySymbol from "../../../utils/CureencySymbol";
import { TbTransferVertical } from "react-icons/tb";
import { getTransferWallet } from "../../../api/getApi";
import { flattenWalletObject } from "../../../utils/flattenObject";
import LoadingBlock from "../../Loading/LoadingBlock";
import { CURRENCY_SYMBOL } from "../../../constant";
import { IoMdArrowDropup } from "react-icons/io";
import LoadingIcon from "../../Loading/LoadingIcon";

const WalletList = ({ openWallet, setOpenWallet }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`header.${key}`);

  const dispatch = useDispatch();
  const memberData = useSelector((state) => state.isMemberInfo, shallowEqual);
  const isTransferWallet = useSelector(
    (state) => state.isTransferWallet,
    shallowEqual
  );

  const [selectedTab, setSelectedTab] = useState("single");
  const [transferLoading, setTransferLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setTransferLoading(true);
    getTransferWallet()
      .then((data) => {
        dispatch(
          storeTransferWallet(flattenWalletObject(data.transferGameWalletInfo))
        );
      })
      .catch((err) => {})
      .finally(() => {
        setTransferLoading(false);
      });
  }, []);

  const navigate = useNavigate();

  const dropdownRef = useRef(null); // 建立 ref 來存取 Dropdown

  const singleWallet = useMemo(() => {
    return memberData.gameWalletInfo || {};
  }, [memberData]);

  const transferWallet = useMemo(() => {
    return isTransferWallet || {};
  }, [isTransferWallet]);

  const walletList = useMemo(() => {
    return { ...singleWallet, ...transferWallet };
  }, [singleWallet, transferWallet]);

  const walletListToArray = useMemo(() => {
    if (search) {
      return Object.keys(walletList).filter((item) =>
        item?.toLowerCase().includes(search?.toLowerCase())
      );
    }
    return Object.keys(walletList);
  }, [walletList, search]);

  return (
    <Dropdown
      className="!absolute !w-[65%]"
      multiple
      icon="none"
      closeOnEscape
      closeOnBlur
      onClose={() => {
        setOpenWallet(false);
      }}
      open={openWallet}
      ref={dropdownRef}
    >
      <Dropdown.Menu
        onClick={(event) => event.stopPropagation()}
        className="!absolute !left-[-70px] !top-[40px] w-[280px]"
      >
        <Input
          onClick={(event) => event.stopPropagation()}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          icon="search"
          placeholder={i18n("Search")}
          className="search custom-input input-ui !mt-[10px] !mb-[5px] !w-[90%] !mx-auto"
        />
        <Dropdown.Menu className="!border-t-0" scrolling>
          {Object.keys(walletList)?.length === 0 ? (
            <div className="!flex items-center justify-center !py-[5px]">
              <span className="text-[#C9C9C9] font-semibold">No Data</span>
            </div>
          ) : (
            walletListToArray
              ?.sort((a, b) => walletList[b] - walletList[a])
              .map((item, index) => {
                return (
                  <Dropdown.Item
                    className={`${
                      index % 2 === 0 && "bg-[#F2F2F2]"
                    } !flex items-center justify-between group !py-[5px]`}
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate(`profile/data/point-query/${item}`);
                    }}
                    key={item}
                  >
                    <div className="flex items-center">
                      <span className="w-[30px] text-sm font-semibold tracking-tighter">
                        {item?.toUpperCase()}
                      </span>
                    </div>

                    <p className="mb-0 text-sm font-medium text-overflow">
                      <LoadingIcon commonLoading={transferLoading}>
                        {CURRENCY_SYMBOL}
                        {formatNumber(walletList?.[item])}
                      </LoadingIcon>
                    </p>
                    <div>
                      <TbTransferVertical
                        className={`group-hover:border-main-color group-hover:text-main-color transition duration-300 rounded-full p-[3px] border border-[#B6BBC4] text-xl cursor-pointer text-[#B6BBC4]`}
                      />
                    </div>
                  </Dropdown.Item>
                );
              })
          )}
        </Dropdown.Menu>
        <Dropdown.Divider />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(WalletList);
